import { Injectable } from '@angular/core';
import { LearnerHelperService } from './learner-helper.service';
import { NetwordDetectionService } from 'modules/app/services/network-detection.service';
import { UserdataService } from './userdata.service';
import { HelperService } from './helper.service';
import { EbookHelperService } from './ebook-helper.service';
import { DesktopDatabaseHelperService } from './desktop-database-helper.service';
import { DownloadHelperService } from './download-helper.service';
@Injectable()
export class ProductEntitlementsService {
    entitlementsList;


    constructor(
        private learnerHelperService: LearnerHelperService,
        private networkService: NetwordDetectionService,
        private userdataService: UserdataService,
        private helperService: HelperService,
        private ebookHelperService: EbookHelperService,
        private desktopDatabaseHelperService: DesktopDatabaseHelperService,
        private downloadHelperService: DownloadHelperService,
    ) {

    }

    //Get product Data from Product Code
    public getUmbrellaofProduct(productcode): Product {
        return this.entitlementsList.find((bundle) => { return bundle.products.some((product) => { return product['dls-product'].code == productcode }) });
    }

    /**
     * Get list of all entitlements for a learner
     * Select only bundles with imagebook component
     * Convert the selected bundles into required format for display on dashboard
     * Set The finalized list as product to be retrived later instead of sending network call again 
     */
    public async fetchLearnerEntitlements() {
        let user = this.userdataService.getLoggedInUser();
        //Save latest data to DB if online

        // if data is already present then return without new fetch.
        let userEntitlements = await this.getUserEntitlementsData();
        if (userEntitlements) {
            return userEntitlements;
        }

        let isOnline = await this.networkService.isOnline(true);

        if (isOnline) {
            let entitlementsData = await this.learnerHelperService.getLearnerEntitlementsData().toPromise();
            // Set this data in DB. Fetch from DB. Modify the data.
            // save learner spaces here.
            if (entitlementsData && entitlementsData.entitlements) {
                let requiredData = {
                    data: {
                        entities: entitlementsData.entitlements
                    }
                }
                let retrivedData = await this.transformLearnerEntitlementsData(requiredData);
                this.saveUserEntitlementsToDB(user, entitlementsData.entitlements, true);
                return retrivedData;
            }
        } else {

            //Get Data from DB
            let retrivedData = await this.fetchSavedEntitlementsFromDB(user);
            retrivedData = await this.transformLearnerEntitlementsData(retrivedData);
            return retrivedData;
        }
    }

    public async getManifests(retrivedData) {
        // classSpaces[0].classes[0].bundles[0].products[0].productcode

        if (retrivedData && retrivedData.entitlements) {
            let productMap = {};
            let options: any = {
                /* "baseURL" : config.app.zipCdn.baseUrl, */
                "books": []
            };

            retrivedData.entitlements.forEach(entitlement => {
                if (entitlement && entitlement.products) {
                    entitlement.products.forEach((product) => {
                        if (product['ext-product'].type == 'imgbook') {
                            productMap[product['dls-product'].code] = {
                                "bundleCode": entitlement['bundle-code'],
                                "product": product
                            };
                        }
                    });
                }
            });

            if (productMap && Object.keys(productMap).length) {

                Object.keys(productMap).forEach((bookCode) => {
                    options.books.push({
                        "bookCode": bookCode,
                        "bundleCode": productMap[bookCode].bundleCode
                    });
                });

                try {
                    let data = await this.ebookHelperService.fetchManifests(options);

                    Object.keys(productMap).forEach((productcode) => {

                        if (data && data[productcode] && data[productcode].manifest && data[productcode].manifest) {

                            let linkedPEs = data[productcode].linkedPEs;
                            let loManifests = data[productcode].loManifest;
                            let hasValidPEManifests = false;

                            if ((!linkedPEs && !loManifests) || (linkedPEs && loManifests && linkedPEs.length && Object.keys(loManifests).length == linkedPEs.length)) {
                                hasValidPEManifests = true;
                            }

                            let manifest = data[productcode].manifest;
                            let { fileSize, version, fileSizeUnit, unZippedFileSize, unZippedFileSizeUnit } = this.ebookHelperService.calculateManifestSize(manifest, loManifests);

                            // DB uupdate required ONLY for two conditions  - manifest node is not present (fallback), version is outdated (i.e., a new published product is present)
                            //The manifest should consist of unzip size 
                            if (manifest.shared.fileSize.unzip && (!productMap[productcode].product.manifest || productMap[productcode].product.manifest.versions != version)) {
                                productMap[productcode].product.manifest = { fileSize, version, fileSizeUnit, unZippedFileSize, unZippedFileSizeUnit, hasValidPEManifests };
                            }else{
                                // if the manifest call does not have unzip size
                                productMap[productcode].product['manifestCallFail'] = true;
                            }
                        }else{
                            // checking if the manifest call failed
                            productMap[productcode].product['manifestCallFail'] = true;
                        }

                    });

                    if (data) {
                        let modeledData = [];
                        Object.keys(data).forEach(key => {
                            modeledData.push({ 'ebookCode': key, 'data': data[key] })
                        });
                        this.downloadHelperService.updateBookAndPEMap(modeledData);
                        this.downloadHelperService.initiateAutoUpdateProcess(modeledData);
                    }

                } catch (err) {
                    console.log("Error while fetching manifests", err);
                }

            }

        }
    }

    // modify user entitlements as required.
    public modelEntitlementsData(entitlements) {
        let user = this.userdataService.getLoggedInUser();
        let dbEntitlementData = [];
        let visitedBundles = [];
        entitlements.forEach(entitlement => {
            if (entitlement.meta && entitlement.meta['bundle-codes'] && entitlement.meta['bundle-codes'][0]) {
                let bundleCode = entitlement.meta['bundle-codes'][0];
                //Check if bundle already iterated
                if (visitedBundles.indexOf(bundleCode) == -1) {
                    //Save bundle as visited bundle
                    visitedBundles.push(bundleCode);
                    let bundle = entitlement.bundles[bundleCode];
                    let bundleEntitlements: Array<Product> = bundle.products.reduce((transformedEntitlementData, product) => {
                        if (product["ext-product"].type == "imgbook") {
                            //Transform data that need to be saved to DB
                            transformedEntitlementData.push(product);
                        } else if (product["ext-product"].type == "OLP") {
                            //Transform data that need to be saved to DB
                            transformedEntitlementData.push(product);
                        }
                        return transformedEntitlementData;
                    }, []);
                    //If the bundle has ebook Product Entitlements, then only insert that bundle-{ebook} entitlement data
                    if (bundleEntitlements.length) {
                        let transformedBundle = { ...bundle };
                        transformedBundle.imageURL = this.helperService.fetchBundleImage(bundle);
                        transformedBundle.products = bundleEntitlements;
                        dbEntitlementData.push(transformedBundle);
                    }
                }
            }
        });

        if (entitlements && entitlements.length) {
            let dbData = {
                uid: user.uid,
                data: { entities: entitlements }
            }

            //If any {bundle-{ebook}} entitlement data exist then save to DB
            if (dbEntitlementData.length) {
                dbData["entitlements"] = dbEntitlementData;
            }

            return dbData;

        }

    }

    // save user entitlements to DB/
    public async saveUserEntitlementsToDB(user, entitlements, updateDB = false) {
        let dbData = {
            uid: user.uid,
            data: { entities: entitlements }
        }
        let options:any = {};
        if(user && (user.role == 'teacher')){
            options.updateImgPath = false;
        }
        await this.desktopDatabaseHelperService.setOriginalEntitlementsData({ entitlementsData: dbData, options }, updateDB);
    }

    // fetch user entitlements from DB.
    public async fetchSavedEntitlementsFromDB(user) {
        let entitlements = await this.desktopDatabaseHelperService.getOriginalEntitlementsData();
        return entitlements;
    }

    // Modify learner entitlements and return.
    public async transformLearnerEntitlementsData(entitlementsData) {
        let retrivedData: any = this.modelEntitlementsData(entitlementsData.data.entities);

        // setting entitlements in the entitlements service.
        // mainly required when app is launched in offline mode.
        // when app is launched in online mode these entitlements are saved just after the api response.
        // but in offline mode api call was not being made thus the entitlement service was empty
        // resulting in blank student dashboard.
        let isOnline = await this.networkService.isOnline(true);
        if (!isOnline && retrivedData && retrivedData.data) {
            this.learnerHelperService.modifyEntitlementsAndActivateProducts(retrivedData.data.entities);
        }

        this.entitlementsList = (retrivedData && retrivedData.entitlements) ? retrivedData.entitlements : [];
        this.getManifests(retrivedData);

        return this.entitlementsList;
    }

    // fetch user entitlements from DB, modify them and return.
    public async fetchModifiedAndSavedEntitlementsOfUser(user) {
        let userEntitlements = await this.fetchSavedEntitlementsFromDB(user);
        let data: any = this.modelEntitlementsData(userEntitlements.data.entities);
        let entitlements = (data && data.data && data.data.entities) ? data.data.entities : [];
        let retrivedData = {
            data: {
                entities: entitlements
            }
        }
        return retrivedData;
    }

    // get userEntitlements saved in memory in service. 
    public async getUserEntitlementsData(getOriginal = false) {
        if (getOriginal) {
            return await this.desktopDatabaseHelperService.getOriginalEntitlementsData();
        } else {
            return this.entitlementsList;
        }
    }

    // reset the entitlements saved in memory.
    public resetLocalCache(resetOriginal = true) {
        if (resetOriginal) {
            this.desktopDatabaseHelperService.resetOriginalData(this.desktopDatabaseHelperService.DATAKEYS.ENTITLEMENTS);
        }
        this.entitlementsList = undefined;
    }

}


export interface Product {
    title: string,
    image: string,
    productcode: string,
    ebookpath?: string,
    description?: string
}